<template>
  <div>
    <div class="pa-3">
      <h4 class="font-weight-bold mt-5 cyan--text text--darken-2">
        <v-icon>mdi-star-four-points</v-icon>
        این بخش در حال توسعه می‌باشد، از صبر و شکیبایی شما سپاس‌گزاریم.
      </h4>
      <img class="float-end" src="/comingSoon.gif" />
    </div>
    <!--<div class="modal-card">
      <h4 class="dark-grey-color mb-9">
        <v-icon color="error">$Chart2</v-icon>
        <span class="ps-2 pe-2 pt-1">گزارش‌ها</span>
      </h4>
      <div class="customSelect mb-6"></div>
      <h5 class="dark-grey-color mb-5 ms-2">
        برای دیدن گزارش هر صفحه بر روی دکمه های زیر کلیک کنید.
      </h5>
      <div class="d-flex justify-center flex-row flex-wrap button-containers">
        <div class="btn-container ms-5 mb-3" style="border: 1px solid #6092cd">
          <v-btn :to="'/shop/rialsalesreport'" class="blue-mainBtn"
            >گزارش‌ ریالی فروش</v-btn
          >
        </div>
        <div class="btn-container ms-5 mb-3" style="border: 1px solid #d20d3e">
          <v-btn :to="'/shop/amountSalesReport'" class="red-mainBtn"
            >گزارش تعداد فروش</v-btn
          >
        </div>
        <div class="btn-container ms-5 mb-3" style="border: 1px solid #7cb342">
          <v-btn :to="'/shop/ReturnedRialReport'" class="lime-mainBtn"
            >گزارش ریالی مرجوعی</v-btn
          >
        </div>
        <div class="btn-container ms-5 mb-3" style="border: 1px solid #7e57c2">
          <v-btn :to="'/shop/ReturnedAmountReport'" class="purple-mainBtn"
            >گزارش تعداد مرجوعی</v-btn
          >
        </div>
      </div>
      <v-row>
        <v-col>
          <v-card class="modal-card mt-5">
            <div class="d-flex flex-row">
              <h4 class="c-grey pt-2 ps-2">بیشترین کالاهای فروخته شده</h4>
            </div>
            <hr class="mt-5" />
            <div class="custom-table mt-3">
              <b-table
                responsive
                show-empty
                :current-page="currentPage"
                :per-page="perPage"
                :items="computedInvoices"
                :fields="fields"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد."
                striped
                thead-class="headClass"
                tbody-class="bodyClass"
              >
                <template v-slot:empty>
                  <div
                    style="text-align: center; vertical-align: middle"
                    class="pt-0"
                  >
                    رکوردی برای نمایش وجود ندارد.
                  </div>
                </template>
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 + perPage * (currentPage - 1) }}
                  </div>
                </template>

                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(totalCost)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ Number(data.value).toLocaleString() + " ریال " }}
                  </div>
                </template>

                <template v-slot:cell(type)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <div
                      class="mx-auto"
                      :class="
                        data.value == 'حقیقی' ? 'purple-badge' : 'green-badge'
                      "
                    >
                      {{ data.value }}
                    </div>
                  </div>
                </template>
              </b-table>
              <v-row class="mt-6">
                <v-col>
                  <v-col class="d-flex flex-row">
                    <span class="c-grey pt-2">نمایش در هر صفحه</span>
                    <div class="ms-3 me-3 number-box">
                      <v-select
                        outlined
                        v-model="perPage"
                        :items="perPageOptions"
                        @change="currentPage = 1"
                      ></v-select>
                    </div>
                  </v-col>
                </v-col>
                <v-col>
                  <div>
                    <v-pagination
                      v-model="currentPage"
                      :total-visible="5"
                      prev-icon="$ArrowLeft"
                      next-icon="$ArrowRight"
                      class="float-end"
                    ></v-pagination>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
        <v-col>
          <v-card class="modal-card mt-5">
            <div class="d-flex flex-row">
              <h4 class="c-grey pt-2 ps-2">بیشترین تعداد مرجوعی</h4>
            </div>
            <hr class="mt-5" />
            <div class="custom-table mt-3">
              <b-table
                responsive
                show-empty
                :current-page="currentPage"
                :per-page="perPage"
                :items="computedInvoices"
                :fields="fields"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد."
                striped
                thead-class="headClass"
                tbody-class="bodyClass"
              >
                <template v-slot:empty>
                  <div
                    style="text-align: center; vertical-align: middle"
                    class="pt-0"
                  >
                    رکوردی برای نمایش وجود ندارد.
                  </div>
                </template>
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 + perPage * (currentPage - 1) }}
                  </div>
                </template>

                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(totalCost)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ Number(data.value).toLocaleString() + " ریال " }}
                  </div>
                </template>

                <template v-slot:cell(type)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <div
                      class="mx-auto"
                      :class="
                        data.value == 'حقیقی' ? 'purple-badge' : 'green-badge'
                      "
                    >
                      {{ data.value }}
                    </div>
                  </div>
                </template>
              </b-table>
              <v-row class="mt-6">
                <v-col>
                  <v-col class="d-flex flex-row">
                    <span class="c-grey pt-2">نمایش در هر صفحه</span>
                    <div class="ms-3 me-3 number-box">
                      <v-select
                        outlined
                        v-model="perPage"
                        :items="perPageOptions"
                        @change="currentPage = 1"
                      ></v-select>
                    </div>
                  </v-col>
                </v-col>
                <v-col>
                  <div>
                    <v-pagination
                      v-model="currentPage"
                      :total-visible="5"
                      prev-icon="$ArrowLeft"
                      next-icon="$ArrowRight"
                      class="float-end"
                    ></v-pagination>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>-->
  </div>
</template>

<script>
import Axios from "axios";
import Var from "../../../variables";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import router from "../../router";
import moment from "moment-jalaali";
// import VueBarcode from "vue-barcode";
import MyCalendar from "../../components/MyCalendar.vue";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    // barcode: VueBarcode,
    MyCalendar,
  },

  data: function () {
    return {
      fields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام" },
        { key: "price", label: "کد" },
        { key: "amount", label: "تعداد مرجوعی" },
        { key: "totalPrice", label: "مبلغ مرجوعی" },
        { key: "status", label: "موجودی کنونی" },
      ],
    };
  },

  methods: {},
  computed: {},

  mounted() {},
};
</script>

<style lang="scss">
.reports {
  background-color: #e5e5e5 !important;
  min-height: 100vh;
  border-radius: 15px;
}
.btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 250px;
  height: 150px;
  background-color: #fff;
  border-radius: 20px;
}
</style>
